export default {
  createNewUser: 'Create new user',
  searchPlaceholder: 'User name, email',
  user: 'User',
  role: 'Role',
  pillar: 'Pillar(s)',
  status: 'Status',
  actions: 'Actions',
  fullName: '{{firstName}} {{lastName}}',
  noUsersFound: 'No users found',
  roles: {
    administrator: 'Administrator',
    facilitator: 'Facilitator',
    contributor: 'Contributor',
    auditor: 'Auditor',
    signatory: 'Signatory',
    'company-admin': 'Administrator',
  },
  statuses: {
    invited: 'Invited',
    deactivated: 'Deactivated',
    active: 'Active',
  },
};
